import Main from './Main'
import Lista from './components/Seguradora'
import Novo from './components/NovoSeguradora'

export default [
  {
    path: 'pc-seguradora',
    name: 'policiacivil.processo.seguradora',
    component: Main,
    redirect: { name: 'policiacivil.processo.seguradora.list' },
    children: [
      {
        path: '/',
        name: 'policiacivil.processo.seguradora.list',
        component: Lista
      },
      {
        path: 'registro',
        name: 'policiacivil.processo.seguradora.novo',
        component: Novo
      },
      {
        path: ':id',
        name: 'policiacivil.processo.seguradora.edit',
        component: Novo
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/policia-civil/processo/seguradora/routes.js